import { TextNova } from "@/components/TextNova";
import { usePrismic } from "@/hooks/usePrismic";
import { IconApp } from "@/modules/IconApp";
import { ChannelCart } from "@/views/ChannelCart";
import { useNavigate } from "react-router";
import { HomeContainer } from "./style";

export const Home = () => {
  const t = usePrismic();
  const navigate = useNavigate();

  return (
    <HomeContainer>
      <div>
        <IconApp name="shield" color="blueGray400" fontSize={24} />
        <TextNova variant="span">{t.home.securityMessage}</TextNova>
      </div>
      <div>
        <div>
          <iframe
            width="652"
            height="276"
            src="https://www.youtube.com/embed/YIpI0mgw6CM"
            title="Únete a Novaventa"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          />
          <TextNova variant="subtitle3">{t.home.subtitle}</TextNova>
          <TextNova variant="text">{t.home.description}</TextNova>
        </div>
        <div>
          <TextNova variant="title">{t.home.title}</TextNova>
          <ChannelCart
            icon="laptop"
            texts={t.home.channels.autogestion}
            onClick={() => navigate("/auto-gestion/login-documento")}
          />
          <ChannelCart
            icon="users"
            texts={t.home.channels.presencial}
            onClick={() => navigate("/llamada-experto/login-documento")}
          />
        </div>
      </div>
    </HomeContainer>
  );
};

export default Home;
